// removed by extract-text-webpack-plugin
module.exports = {"classResponsiveness":"style-classResponsiveness-0abaf86e"};


//////////////////
// WEBPACK FOOTER
// ./src/Common/ViewportDetector/style.scss
// module id = 912
// module chunks = 0